/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconXd = createReactComponent("xd", "IconXd", [
  ["path", { d: "M6 8l4 8", key: "svg-0" }],
  ["path", { d: "M6 16l4 -8", key: "svg-1" }],
  [
    "path",
    { d: "M14 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", key: "svg-2" }
  ]
]);

export { IconXd as default };
//# sourceMappingURL=IconXd.js.map
